import { InlineInput } from '@/components/ui/inline-input';
import Loader from '@/components/ui/loader';
import { EHR_PATIENT_SEARCH_MIN_QUERY_LENGTH } from '@/features/integrations-ehr/ehr-patient-search/constants';
import { toEhrPatientSearchResultView } from '@/features/patient-find-or-link/adapters/to-ehr-patient-search-result-view';
import { type PatientSearchComboboxHost } from '@heidi/patients';

import { emitPatientProfileSurfaceEvent } from '../patient-profile/usePatientProfileHost';

/** Binds the search combobox to the app input, loader, and EHR adapter. */
export function usePatientSearchComboboxHost(): PatientSearchComboboxHost {
  return {
    InlineInput,
    Loader,
    adaptEhrResult: toEhrPatientSearchResultView,
    ehrMinQueryLength: EHR_PATIENT_SEARCH_MIN_QUERY_LENGTH,
    emitSurfaceEvent: emitPatientProfileSurfaceEvent,
  };
}
